// src/pages/PrivacyPage.js

import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export default function PrivacyPage() {
  const { i18n } = useTranslation();
  const [privacy, setPrivacy] = useState(null);

  useEffect(() => {
    const lang = i18n.language || "es";
    fetch(`/locales/${lang}/privacy.json`)
      .then((res) => res.json())
      .then(setPrivacy)
      .catch(() => console.error("❌ Error al cargar la política de privacidad"));
  }, [i18n.language]);

  if (!privacy) {
    return <p className="text-center mt-10">Cargando política de privacidad...</p>;
  }

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10 sm:py-14 text-slate-800">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[#245580] mb-3">{privacy.title}</h1>
      <p className="text-sm text-slate-600 mb-10">{privacy.last_update}</p>

      {privacy.sections.map((section, idx) => (
        <section key={idx} className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold text-[#245580] mb-4">{section.title}</h2>
          {section.body && (
            <p className="text-base leading-8 whitespace-pre-line mb-4">{section.body}</p>
          )}
          {section.list && (
            <ul className="list-disc ml-6 space-y-3 text-base leading-7">
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
